import React from 'react';
import styles from './ui.module.css';

interface MeterProps {
  /** The value as a percentage of the whole, 0–100. */
  value: number;
  /** Scale the bar against the largest row instead of 100%, so small shares stay visible. */
  max?: number;
  /** Text shown beside the bar. Defaults to `value` with one decimal and a % sign. */
  label?: React.ReactNode;
  /** Use the neutral blue fill — for shares that are not "good", just large. */
  neutral?: boolean;
}

/**
 * An inline share-of-total bar for weight and exposure columns: the number
 * still reads exactly, and the bar makes the ranking scannable without
 * sorting.
 */
const Meter: React.FC<MeterProps> = ({ value, max = 100, label, neutral }) => {
  const safe = Number.isFinite(value) ? Math.max(value, 0) : 0;
  const ceiling = max > 0 ? max : 100;
  const width = Math.min((safe / ceiling) * 100, 100);
  return (
    <span className={styles.meter}>
      <span className={styles.meterTrack}>
        <span
          className={`${styles.meterFill}${neutral ? ` ${styles.meterFillNeutral}` : ''}`}
          style={{ width: `${width}%` }}
        />
      </span>
      <span className={styles.meterValue}>{label ?? `${safe.toFixed(1)}%`}</span>
    </span>
  );
};

export default Meter;
